import { CoverImage } from "@/react/components/Layout/StandardLayoutV2/CoverImage";
import { STANDARD_LAYOUT_V2_COVER_IMAGE_CONTAINER as id } from "@/react/components/constants";
import { AsyncPortal } from "@circle-react-uikit/AsyncPortal";

export interface MobileCoverImageProps {
  thumbnailImageUrl?: string;
  coverImageUrl: string;
}

export const MobileCoverImage = ({
  thumbnailImageUrl,
  coverImageUrl,
}: MobileCoverImageProps) => {
  const url = thumbnailImageUrl || coverImageUrl;
  const isThumbnail = !!thumbnailImageUrl;
  return (
    <AsyncPortal selectorQuery={`#${id}`}>
      <CoverImage url={url} thumbnail={isThumbnail} />
    </AsyncPortal>
  );
};
